interface Args {
	namePrefix: string;
	propertyName: string;
	internalName: string;
}

export const getFieldNameCompany = ({ namePrefix, propertyName, internalName }: Args) => {
	return `${namePrefix}${propertyName}.${internalName}`;
};
